// src/pages/SalesReturnLedger/SalesReturnLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSalesReturnLedgerApi } from "../../apiservice/reports";
import { getAccountByTypeApi } from "../../apiservice/setting";

export const fetchSalesReturnLedger = createAsyncThunk(
  "salesReturnLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getSalesReturnLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSaleReturnAccounts = createAsyncThunk(
  "salesReturnLedger/fetchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "sale_return" });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);